module.exports = __webpack_public_path__ + "img/推荐算法开发者.6408f7df.png";